import { NgModule } from '@angular/core';
import { ConfigsApplication } from './service/configs.application';
import { SystemConfigInfructureLayerModule } from '../infrustructure-layer/system-config-infrustructre-layer.module';
import { SystemConfigDomainLayerModule } from '../domain-layer/system-config-domain-layer.module';

@NgModule({
  providers: [ConfigsApplication],
  imports: [SystemConfigInfructureLayerModule, SystemConfigDomainLayerModule],
  exports: [],
})
export class SystemConfigApplicationModule {}
